/**
 * Docs search service — calls the backend /api/chat/sessions/{uuid}/docs-search endpoint. Independent from
 * the chat agent loop; bypasses the classifier entirely.
 */
import { createAxiosInstance } from "@/dataProvider/axios";
import { DEV_AGENT_BASE_URL, devAgentAuthHeaders, withUserId } from "@/pages/dev-agent/devAgentService";

const docsAxios = createAxiosInstance(`${DEV_AGENT_BASE_URL}/api`);

export interface DocsSearchResult {
  title: string;
  url: string;
  snippet: string;
  category: string;
  source: string;
}

/**
 * Run the docs search AND inject results as a user + assistant message
 * pair into the given chat session. Bypasses the agent loop — this is
 * the direct, deterministic "search in chat" path.
 */
export async function searchDocsInChat(
  sessionUuid: string,
  query: string,
): Promise<{
  query: string;
  result_count: number;
  user_message: { uuid: string; content: string };
  assistant_message: { uuid: string; content: string };
}> {
  const response = await docsAxios.post(
    withUserId(`/chat/sessions/${sessionUuid}/docs-search`),
    { query },
    { headers: devAgentAuthHeaders() },
  );
  const data = response.data as unknown as { data?: any };
  if (data && typeof data === "object" && "data" in data && data.data) {
    return data.data;
  }
  return response.data as any;
}
